import { atom } from 'recoil';

// 0 カード | 1 リスト
export type listViewType = 0 | 1;
export const listViewStore = atom<listViewType>({
  key: 'listViewStore',
  default: 0,
});
